import { render, staticRenderFns } from "./imageCenter.vue?vue&type=template&id=524b2b09&scoped=true"
import script from "./imageCenter.vue?vue&type=script&lang=js"
export * from "./imageCenter.vue?vue&type=script&lang=js"
import style0 from "./imageCenter.vue?vue&type=style&index=0&id=524b2b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b2b09",
  null
  
)

export default component.exports